import { ref } from 'vue'
import { defineStore } from 'pinia'

const STORAGE_KEY_TF = 'sr_selectedTimeFrameId'
const STORAGE_KEY_ENT = 'sr_selectedEntityId'

function loadFromStorage(key: string): number | null {
  const val = localStorage.getItem(key)
  return val ? Number(val) : null
}

export const useEntityStore = defineStore('entity', () => {
  const selectedTimeFrameId = ref<number | null>(loadFromStorage(STORAGE_KEY_TF))
  const selectedEntityId = ref<number | null>(loadFromStorage(STORAGE_KEY_ENT))

  function select(timeFrameId: number, entityId: number) {
    selectedTimeFrameId.value = timeFrameId
    selectedEntityId.value = entityId
    localStorage.setItem(STORAGE_KEY_TF, String(timeFrameId))
    localStorage.setItem(STORAGE_KEY_ENT, String(entityId))
  }

  function $reset() {
    selectedTimeFrameId.value = null
    selectedEntityId.value = null
    localStorage.removeItem(STORAGE_KEY_TF)
    localStorage.removeItem(STORAGE_KEY_ENT)
  }

  return {
    selectedTimeFrameId,
    selectedEntityId,
    select,
    $reset,
  }
})
